import React from "react";
import "./style.css";

export const ContactIconSummary = () => {
  return (
    <div className="contact-icon">
      <img className="vector" alt="Vector" src="../images/vector.svg" />
    </div>
  );
};
